export default {
      id: "icon--groups-nav-usage",
      viewBox: "0 0 22.8 19.1",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--groups-nav-usage",
      toString: function () {
        return this.url;
      }
    }